import { Flex } from '@chakra-ui/react';
import { useProdFeatureFlagEnabled } from '~/common/hooks/useProdFeatureFlagEnabled';
import { useListingPageContext } from '../../ListingPageContext';
import {
  DownloadPdfButton,
  OfferScorecardButton,
  ShareWithClientButton,
} from '../ActionButtons';

export const ListingPageMobileActionBar = () => {
  const { isViewOnly } = useListingPageContext();
  const isDownloadPdfEnabled = useProdFeatureFlagEnabled(
    'listing-report-pdf-generation'
  );

  if (isViewOnly) {
    return null;
  }

  return (
    <Flex
      bg="bg.main"
      borderColor="border.divider"
      borderTopWidth="1px"
      bottom={0}
      gap={2}
      justifyContent="center"
      p={4}
      position="sticky"
      width="100%"
      zIndex={4}
    >
      <OfferScorecardButton flex={1} />
      <ShareWithClientButton iconOnly={false} />
      {isDownloadPdfEnabled && <DownloadPdfButton iconOnly={false} />}
    </Flex>
  );
};
